export default __webpack_public_path__ + "static/media/BrainlabNowW05-Regular.7d109119.woff2";